import { Button, Typography } from '@mui/material'
import { OverlayState } from '@/hooks/useOverlay'
import { Dialog, DialogContent, DialogFooter } from '@/components/dialog'

type CommentDeleteDialogProps = {
  overlay: OverlayState
  onClose: () => void
  onConfirm: () => void
}

export default function CommentDeleteDialog({
  overlay,
  onClose,
  onConfirm,
}: CommentDeleteDialogProps) {
  return (
    <Dialog
      {...overlay}
      title="Delete comment?"
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      disableClickAway={false}
      disableEscapeKeyDown={false}
    >
      <DialogContent>
        <Typography color="text.secondary">
          This will remove your comment for everyone. This can&apos;t be undone.
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm}>
          Delete
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
